import { render } from "./LinkageTerms.vue?vue&type=template&id=d7e47d20&scoped=true&ts=true"
import script from "./LinkageTerms.vue?vue&type=script&lang=ts"
export * from "./LinkageTerms.vue?vue&type=script&lang=ts"

import "./LinkageTerms.vue?vue&type=style&index=0&id=d7e47d20&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1253990065/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7e47d20"]])

export default __exports__